import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
  DataGridPro,
  GridActionsCellItem,
  GridToolbarFilterButton,
  GridColDef,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import DeleteIcon from "@mui/icons-material/Delete";
import { AppraisalAttachment } from "../../../all_Interfaces";
import { useAppSelector } from "../../../redux/hooks";
import { useDispatch } from "react-redux";
import { updateAttachments } from "../../../redux/slices/UpdateExistingAttachmentSlice";
import { addNewAttachments } from "../../../redux/slices/AddNewAttachmentsSlice";
import { useParams } from "react-router-dom";
import { getApiCall, getDownloadFile, postApiCall } from "../../../services/apiHelper";
import { DocumentServiceURL } from "../../../config/config";
import { ServiceName } from "../../../constants";
import { CircularProgress, Tooltip } from "@mui/material";
import dayjs from "dayjs";
import axios from "axios";
import JSZip from "jszip";
import { saveAs } from 'file-saver';
export const DocumentList = (props:any) => {
  const dispatch = useDispatch();
  const params = useParams();
  const page = params.page;
  const editDisplay =
    window.location.pathname.includes("edit") ||
    window.location.pathname.includes("view");
  const newpage = window.location.pathname.includes("new");
  const [open, setOpen] = React.useState(false);
  const [attachments, setAttachments] = useState<AppraisalAttachment[]>([]);
  const [newAttachments, setNewAttachments] = useState<AppraisalAttachment[]>(
    []
  );
  const [existingAttachments, setExistingAttachments] = useState<
    AppraisalAttachment[]
  >([]);
  const [deleteFile, setDeleteFile] = useState<AppraisalAttachment | null>(
    null
  );
  const attachmentList: AppraisalAttachment[] = useAppSelector(
    (state) => state.UpdateExistingAttachments.data
  );
  const ExistingNewAttachmentsRDX: AppraisalAttachment[] = useAppSelector(
    (state) => state.AddNewAttachments.data
  );
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    var tempAttachments: AppraisalAttachment[] = [];
    if (attachmentList.length != 0) {
      if (props.docType != "All") {
        tempAttachments = attachmentList.filter(
          (file: AppraisalAttachment) => file.doctype === props.docType
        );
      } else {
        tempAttachments = [...attachmentList];
      }
    }
    setAttachments(tempAttachments);
    setNewAttachments(attachmentList);
    console.log(attachmentList);
  }, [attachmentList, props.docType]);

  useEffect(() => {
    setExistingAttachments(ExistingNewAttachmentsRDX);
    console.log(ExistingNewAttachmentsRDX);
  }, [ExistingNewAttachmentsRDX, props.docType]);

  const handleDeleteOpen = () => {
    setOpen(true);
  };
  const handleDeleteClose = () => {
    setDeleteFile(null);
    setOpen(false);
  };

  const downloadFilePresignedUrl = (row: AppraisalAttachment) => {
    const key = row.guid + "_" + row.doctype + "_" + row.fileName;
    if (row.fileName.includes(".avux")) {
      downloadFile(row);
    } else {
      getApiCall(
        DocumentServiceURL + "/Documents/getPreSignedUrl?fileKey=" + key,
        ServiceName.DOCUMENTSERVICE
      ).then((res: any) => {
        const url = res.fileUrl;
        console.log(url);
        const fileName = row.fileName;
        const fileExtension = fileName.split(".").pop();

        const link = window.document.createElement("a");
        link.href = url;
        link.setAttribute("style", "display:none;"); // Set the desired filename
        window.document.body.appendChild(link);
        link.target = "_blank"; // Open in a new tab

        // Programmatically trigger the download
        link.click();
        // Cleanup
        link.parentNode?.removeChild(link);
      });
    }
  };

  const downloadFile = async (row: AppraisalAttachment) => {
    const key = row.guid + "_" + row.doctype + "_" + row.fileName;
    const fileName = row.fileName;
    try {
      // Assuming you pass the 'fileKey' as a query parameter
      getDownloadFile(
        DocumentServiceURL + "/Documents/GetById?fileKey=" + key,
        ServiceName.DOCUMENTSERVICE
      ).then((response: any) => {
        // Create a download link and trigger the file download
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); // Extract the filename from the response headers
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
      });
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const downloadAllFiles = async () => {
    setLoading(true);
    const zip = new JSZip();
    try {
      const fileResponces:any  = await getApiCall(
        DocumentServiceURL +
          "/Documents/getall/" +
          window.location.pathname.split('/')[4],
        ServiceName.DOCUMENTSERVICE
      );
      const urls = await Promise.all(
        fileResponces.map(async (file) => {
          const responce:any  = await getApiCall(
            DocumentServiceURL +
              "/Documents/getPreSignedUrl?fileKey=" +
              file.fileKey,
            ServiceName.DOCUMENTSERVICE
          );
          return zip.file(file.fileName, (await fetch(responce.fileUrl)).arrayBuffer());
        })
      );
      zip.generateAsync({ type: "blob" }).then((content) => {
        let today = new Date();
         let date = today.getDate() + "-" + today.getMonth() + 1 + "-" + today.getFullYear() + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
         if(fileResponces.length > 0)
         {
          saveAs(content, fileResponces[0].fileName.split('_')[0] + '_' + fileResponces[0].fileName.split('_')[1] + '_' + fileResponces[0].fileName.split('_')[2] + '_' + date);
         }
      });
    } catch (error) {
      console.error("Error downloading file:", error);
    }
    setLoading(false);
  };

  const columnName: GridColDef[] = [
    {
      field: "fileName",
      headerName: "File Name",
      editable: false,
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            {editDisplay && (
              <Tooltip title={params.row.fileName} placement="right" arrow>
                <a
                  className="downloadLink"
                  onClick={() => downloadFilePresignedUrl(params.row)}
                >
                  {params.row.fileName}
                </a>
              </Tooltip>
            )}
            {newpage && <>{params.row.fileName}</>}
          </>
        );
      },
    },

    {
      field: "lastModifiedBy",
      headerName: " Uploaded By ",
      flex: 0.3,
      editable: false,
    },
    {
      field: "lastModifiedDate",
      headerName: "Uploaded Date",
      flex: 0.3,
      valueFormatter: (params: any) => {
        console.log(params);
        return `${dayjs(params).format("MMM-DD-YYYY HH:mm:ss")}`;
      }, //`${dayjs(params).format('MMM-DD-YYYY HH:mm:ss')}`},//return `${dayjs(params.value, 'MM/DD/YYYY HH:mm:ss').format('MMM-DD-YYYY HH:mm:ss')}`},
    },
    {
      field: "action",
      headerName: "Actions",
      type: "actions",
      flex: 0.2,
      editable: false,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <>
            <GridActionsCellItem
              icon={<FileDownloadOutlinedIcon />}
              label="Download"
              onClick={() => {
                downloadFile(params.row);
              }}
              color="inherit"
            />
            <GridActionsCellItem
              icon={<DeleteOutlineOutlinedIcon />}
              label="Delete"
              sx={{ marginLeft: 2 }}
              onClick={() => {
                setDeleteFile(params.row);
                handleDeleteOpen();
                console.log(params.row);
              }}
              color="inherit"
            />
          </>
        );
      },
    },
  ];

  const getRowId = (row: any) => {
    return row.fileName; // Specify the unique identifier for each row
  };

  const removeFile = () => {
    const newAttachmentsIndex: number = newAttachments.indexOf(
      deleteFile as AppraisalAttachment
    );
    const existingNewAttachmentsIndex: number = existingAttachments.indexOf(
      deleteFile as AppraisalAttachment
    );
    var key = deleteFile?.fileKey;
    if (key == undefined) {
      key =
        deleteFile?.guid +
        "_" +
        deleteFile?.doctype +
        "_" +
        deleteFile?.fileName;
    }

    // Only call the delete API if the file has a fileKey (meaning it exists in S3)
    // Files that failed to upload or are only in the UI session won't have a valid fileKey from the server
    const isUploadedToS3 = deleteFile?.fileKey != null && deleteFile?.fileKey !== "";

    if (isUploadedToS3) {
      try {
        setLoading(true);
        postApiCall(
          DocumentServiceURL + "/Documents/delete?fileKey=" + key,
          null,
          ServiceName.DOCUMENTSERVICE
        ).then((data: any) => {
          console.log("File deleted from S3:", key);
        }).catch((e: any) => {
          console.log("Error deleting file from S3 (may not exist):", e);
        }).finally(() => {
          setLoading(false);
        });
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    }

    // Always remove from UI state regardless of S3 status
    if (newAttachmentsIndex !== -1) {
      var tempAttachmentList: AppraisalAttachment[] = [...newAttachments];
      tempAttachmentList.splice(newAttachmentsIndex, 1);
      dispatch(updateAttachments(tempAttachmentList));
    }
    if (existingNewAttachmentsIndex !== -1) {
      var tempAttachmentList: AppraisalAttachment[] = [
        ...existingAttachments,
      ];
      tempAttachmentList.splice(existingNewAttachmentsIndex, 1);
      dispatch(addNewAttachments(tempAttachmentList));
    }

    setOpen(false);
  };

  return (
    <Box sx={{ width: "100%" }}>
      {props.docType =="All" &&<Box sx={{ width: "100%" ,display :"flex",justifyContent: "flex-end"}} >
      <Button
        sx={{ textTransform: "none", mb: 1}}
        variant="contained"
        size="medium"
        color="primary"
        onClick={downloadAllFiles}
      >
        Download All
      </Button>
      </Box>}
      {loading && (
        <div className="overlaySpinner">
          <CircularProgress />
        </div>
      )}
      <DataGridPro
        sx={{
          backgroundColor: "white",
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#253746",
            color: "white",
          },
          "& .MuiDataGrid-sortIcon": {
            color: "white",
          },
          "& .MuiDataGrid-filterIcon": {
            color: "white",
          },
        }}
        disableColumnMenu={true}
        rows={attachments ?? []}
        columns={columnName}
        autoHeight={true}
        rowHeight={40}
        getRowId={getRowId}
        hideFooter={true}
        disableRowSelectionOnClick
        className={attachments.length ? "" : "table-no-row-found"}
      />

      <Dialog
        open={open}
        onClose={handleDeleteClose}
        className="common-dialog-box"
      >
        <DialogTitle id="alert-dialog-title">
          {"Delete Confirmation"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete {deleteFile?.fileName} the file?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            sx={{ textTransform: "none" }}
            className="primary"
            variant="outlined"
            onClick={handleDeleteClose}
            autoFocus
          >
            Cancel
          </Button>
          <Button
            sx={{ textTransform: "none" }}
            color="error"
            variant="outlined"
            onClick={removeFile}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
